import { createUseAppTranslation } from '@spendbrain/config/utils';

export const useAppTranslation = createUseAppTranslation('your-team');
